import React, { useState } from "react";
import { Card, CardHeader, Collapse } from "reactstrap";

export const CltDirecciones = ({ clt }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Direcciones"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <div className={"table-responsive"}>
                        <table className="table table-striped table-hover">
                            <thead className="thead-inverse text-primary">
                                <tr>
                                    <th className="text-left">#</th>
                                    <th className="text-left">Provincia</th>
                                    <th className="text-left">Sector</th>
                                    <th className="text-left">Dirección</th>
                                    <th className="text-left">Referencia</th>
                                    <th className="text-left">Observaciones</th>
                                    <th className="text-left">Envíos</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(clt?.direcciones || []).map((d, index) => (
                                    <tr key={d.cdDireccion}>
                                        <td className="text-left">
                                            <span>{index + 1}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{d.ciudad.nmProvincia}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{d.sector.sector}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{d.dscDireccion}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{d.referencia}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{d.observaciones}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{d.envio ? "SI" : "NO"}</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Collapse>
            </Card>
        </div>
    );
};
